<template>
    <div>
        <div class=" tw-px-4 tw-py-3 tw-border-2 tw-border-grey-600 tw-border-solid tw-mb-4 tw-mx-0 md:tw-mx-24" style="border-color: #505050; border-bottom-width: 8px">
            <div class="tw-flex tw-flex-row tw-items-center tw-justify-between">
                <h1 class="tw-text-5xl tw-capitalize tw-text-secondary">
                    {{ production.name }}
                </h1>
                <v-btn @click="manageClick()" class="main-btn">Manage</v-btn>
            </div>
            <div>
                <h3 class="tw-text-2xl">{{ production.alternate_name || 'Alternate Name'}}</h3>
                <h3 class="tw-text-2xl">{{ idDisplay }}</h3>
                <h3 class="tw-text-2xl">{{ production.genre || 'Genre'}}</h3>
            </div>
            <div class="tw-flex">
                <div class="tw-w-1/4"><a :href="`mailto:${production.emails[0]?.email}`">{{ production.emails[0]?.email || 'Email' }}</a></div>
                <div class="tw-w-1/4">{{ production.telephones[0]?.telephone_fax || 'Phone Number' }}</div>
                <div class="tw-w-1/4">{{ production.location || 'Location' }}</div>
                <div class="tw-w-1/4">{{ production.contract?.name || 'Contract'}}</div>
            </div>
        </div>

        <div class="tw-flex tw-flex-col">
            <v-tabs v-model="current_tab" grow active-class="active-tab" slider-size="0" height="35" class="tw-pt-3">
                <v-tab class="tw-border-b-2 tw-border-secondary tw-mr-2">Overview</v-tab>
                <v-tab class="tw-border-b-2 tw-border-secondary tw-mr-2">Crew</v-tab>
                <v-tab class="tw-border-b-2 tw-border-secondary tw-mr-2">Statistics</v-tab>

                <v-tab-item class="tw-py-4"><productions-show-overview :input="production" :constants="constants" :valuelists="valuelist"/></v-tab-item>
                <v-tab-item class="tw-py-4"><productions-show-crew :input="production" :constants="constants" :valuelists="valuelist"/></v-tab-item>
                <v-tab-item class="tw-py-4"><productions-show-statistics :input="production" :constants="constants" :valuelists="valuelist"/></v-tab-item>
            </v-tabs>
        </div>
    </div>
</template>

<script>
    import SmartTable from "@/Generic/SmartTable";
    import AppLayout from "@/Layouts/AppLayout.vue";
    import InternalHeader from "@/Generic/InternalHeader";
    import InternalTableSection from "@/Generic/InternalTableSection";
    import ProductionsShowOverview from "@/Pages/InternalPages/Productions/ProductionsShowOverview";
    import ProductionsShowStatistics from "@/Pages/InternalPages/Productions/ProductionsShowStatistics";
    import ProductionsShowCrew from "@/Pages/InternalPages/Productions/ProductionsShowCrew";

    export default {
        name: "ProductionsShow",
        layout: (h, page) => {
            return h(AppLayout, [
                page
            ])
        },
        components: {
            SmartTable,
            InternalHeader,
            InternalTableSection,
            ProductionsShowOverview,
            ProductionsShowStatistics,
            ProductionsShowCrew

        },
        remember: {
            data: [
                'items'
            ]
        },
        props: {
            'input': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'valuelists': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
        },
        data() {
            return {
                search: null,
                production: this.input,
                constant: this.constants,
                valuelist: this.valuelists,
                current_tab: null
            }
        },
        computed: {
            idDisplay() {
                return [this.production.id, this.production.remit_id].filter(Boolean).join(' - ')
            }
        },
        methods: {
            manageClick() {
                this.$inertia.visit(route('productions.edit', this.production.id))
            },
            reloadInput() {
                this.$inertia.reload({only: ['input']})
            },
            generateList(object, key, valuelist) {
                let list = []
                if (valuelist === undefined) {
                    list = object.map(obj => eval(`obj.${key}`))
                } else {
                    list = object.map(obj => this.findValuelist(valuelist, eval(`obj.${key}`)).text)
                }
                let listWithoutDuplicates = [...new Set(list)]
                return listWithoutDuplicates.join(', ')
            },
        },
        watch: {
            input(newInput, oldInput) {
                this.production = newInput
            },
        }
    }
</script>

<style scoped>
.active-tab {
    background-color: #ece4df;
    color: #3c47d1 !important;
    font-weight:bold;
}
</style>
